import { render, staticRenderFns } from "./DemandeReconnaissanceArmCanada.vue?vue&type=template&id=55156a85"
import script from "./DemandeReconnaissanceArmCanada.vue?vue&type=script&lang=js"
export * from "./DemandeReconnaissanceArmCanada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports